<script>
export default {
	inheritAttrs: false
};
</script>

<script setup>
import { computed, ref, watchEffect } from "vue";

const props = defineProps(["class", "style", "innerClass", "innerStyle", "error", "label", "tooltip", "modelValue"]);

const emit = defineEmits(["update:modelValue"]);

const radio = ref(null);

const checkedValue = computed({
	get() {
		return props.modelValue;
	},
	set(value) {
		emit("update:modelValue", value);
	}
});

watchEffect(() => {
	if (radio.value)
		radio.value.setCustomValidity(typeof props.error !== "undefined" ? props.error : "");
});
</script>

<template>
	<label :class="class" :style="style" class="vui-radio">
		<input
			ref="radio"
			v-model="checkedValue"
			:class="innerClass"
			:style="innerStyle"
			v-bind="$attrs"
			type="radio"
		>
		<div class="label">
			<slot>{{ label }}</slot>
		</div>
		<i v-if="tooltip" class="fa-solid fa-square-info tooltip" @click.prevent><div class="tooltip-content">{{ tooltip }}</div></i>
	</label>
</template>
